import React from "react";
import { useSelector } from "react-redux";
import styled, { css } from "styled-components";

import { ReactComponent as UserSVG } from "assets/img/User.svg";

import PhoneMask from "containers/PhoneMask";

import breakpoints from "_constants/breakpoints";
import { phoneCleaner } from "_helpers";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 500px;
  min-height: 270px;
  padding: 32px;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 48px;
  background-color: #ffffff;
  box-shadow: 0px 3px 25px rgba(168, 168, 168, 0.3);

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          width: 100%;
          align-items: center;
          padding: 16px 14px 21px;
          margin-bottom: 14px;
        `
      : css`
          @media (max-width: 1350px) {
            width: 90%;
            order: 2;
            margin-bottom: 24px;
          }
        `}
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      flex-direction: column;
    `}
`;
const Title = styled.div`
  font-family: "Montserrat";
  font-size: 24px;
  line-height: 32px;
  color: #7b848d;
  font-weight: bold;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      text-align: center;
      font-size: 22px;

      @media (max-width: ${breakpoints.mobileM}) {
        font-size: 18px;
      }
    `}
`;
const UserAva = styled.div`
  width: 120px;
  height: 120px;
  margin-top: 24px;
  margin-right: 24px;
  & > svg {
    width: 100%;
    height: 100%;
  }

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      max-width: 75px;
      max-height: 75px;
      margin-right: 0px;
    `}
`;
const InfoCol = styled.div`
  margin-top: 24px;
  width: 100%;
`;
const InfoRow = styled(Row)`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 48px;
  border-top: 1px solid #ecedf1;
  padding-left: 14px;

  &:last-child {
    border-bottom: 1px solid #ecedf1;
  }
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      height: 64px;
      flex-direction: column;
      padding-left: 0px;
      height: auto;
      margin-bottom: 12px;
    `}
`;
const Label = styled.div`
  min-width: 72px;
  font-family: "Montserrat";
  font-size: 14px;
  line-height: 24px;
  color: #7b848d;

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 14px;
      text-align: center;
      @media (max-width: ${breakpoints.mobileM}) {
      }
    `}
`;
const Data = styled(Label)`
  font-family: "Montserrat";
  font-weight: bold;
  word-break: break-all;
  white-space: normal;
  line-height: 16px;

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          max-width: 100%;
          @media (max-width: ${breakpoints.mobileM}) {
            font-size: 12px;
            min-height: auto;
          }
        `
      : css`
          @media (max-width: 1350px) {
            width: 100%;
          }
        `}
`;
const Phone = styled.div`
  border: none;
  font-family: "Montserrat";
  font-size: 14px;
  line-height: 24px;
  width: max-content;
  font-weight: bold;
  color: #7b848d;

  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      max-width: 100%;
      @media (max-width: ${breakpoints.mobileM}) {
        font-size: 12px;
      }
    `}
`;

export default function UserProfile() {
  const { userInfo: user } = useSelector(({ user }) => user);

  return (
    <Container>
      <Title>User Profile</Title>
      <Row>
        <UserAva>
          <UserSVG />
        </UserAva>

        <InfoCol>
          <InfoRow>
            <Label>User:</Label>
            <Data>
              {user.firstName} {user.lastName}
            </Data>
          </InfoRow>

          <InfoRow>
            <Label>Email:</Label>
            <Data>{user.email}</Data>
          </InfoRow>

          <InfoRow>
            <Label>Phone:</Label>
            <Phone as={PhoneMask} value={phoneCleaner(user.phone) || ""} />
          </InfoRow>
        </InfoCol>
      </Row>
    </Container>
  );
}
